<template>
  <div>
    <ots-main-title></ots-main-title>
    <div class="systemBox">
      
      <!-- (1) 系统名称设置 -->
      <div class="section mt20">
        <h1>系统名称设置</h1>
        <div class="setState">
          <span>系统名称</span>
          <!-- @blur="ChangeSystemName()" -->
          <el-input v-model="requestForm.systemName" placeholder="弘成慧考平台" ></el-input>
          <!-- <span style="margin-left: 72px; color: #9299A6;">不超过8个汉字</span> -->
          <!-- <span @click="ShowLoginHTML" style="cursor: pointer;">查看效果</span> -->
          <p class="numExplit">系统名称用于登录平台后首页名称的展示，请设置2-20个字符，不包括@&lt;&gt;等无效字符&nbsp;&nbsp;&nbsp;&nbsp;</p>
        </div>
      </div>

      <!-- 登录页标题设置 -->
      <div class="section mt20">
        <h1>登录页标题设置</h1>
        <div class="setState">
          <span>&nbsp;&nbsp;</span>
          <ots-editor class="editor" v-model="requestForm.loginPageTitle" />
          <p class="numExplit">登录页标题用于登录页名的展示&nbsp;&nbsp;&nbsp;&nbsp;<span @click="ShowLoginHTML" style="cursor: pointer;">查看效果</span></p>
        </div>
      </div>

      <!-- 首页展示欢迎语 -->
      <div class="section mt20">
        <h1>首页欢迎语</h1>
        <div class="setState SetWelcome">
            是否在首页展示欢迎语：
            <el-radio-group v-model="requestForm.welcomeMsgFlag">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">隐藏</el-radio>
            </el-radio-group>
          <p v-if="requestForm.welcomeMsgFlag==1">
            请设置欢迎语：<el-input v-model="requestForm.welcomeContent" placeholder="请设置欢迎语"></el-input>
          </p>
        </div>
      </div>

      <!-- (2) LOGO 设置  -->
      <div class="section mt20">
        <h1>LOGO设置</h1>
        <div class="setState">
          <el-radio-group v-model="requestForm.isUsedLogo">
            <el-radio :label="0">
              默认
              <div class="LOGOBorder" style="padding: 13px 26px; box-sizing: border-box;">
                <img :src="DefaultLOGO" alt="">
              </div>
            </el-radio>
            <el-radio :label="1">
              自定义
              <div class="LOGOBorder">
                <el-upload class="avatar-uploader" action="" :show-file-list="false" :on-success="Success_LOGO" :before-upload="beforeUpload_LOGO" :http-request="uploadLogo">
                  <img v-if="requestForm.logoUrl" :src="requestForm.logoUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon">
                    <span class="text">上传LOGO</span>
                  </i>
                </el-upload>
              </div>
            </el-radio>
          </el-radio-group>
          <span class="LogoSet">建议图片高&lt;50像素，大小&lt;100KB，LOGO背景为透明背景</span>
          <p class="numExplit">此logo将同步应用到登录页、平台内页头部、移动端登录页等&nbsp;&nbsp;&nbsp;&nbsp;<span @click="ShowLoginHTML"  style="cursor: pointer;">查看效果</span></p>
        </div>
      </div>

      <!-- (3) 登录页轮播图设置 -->
      <div class="section mt20">
        <h1>登录页轮播图设置 <span>（最多支持上传5张轮播图）</span></h1>
        <div class="setState SetSwiper">
          <p class="numExplit">此背景图片将同步应用到登录页轮播图&nbsp;&nbsp;&nbsp;&nbsp;<span @click="ShowLoginHTML" style="cursor:pointer;">查看效果</span></p>
          <div class="AddSwiper" @click="AddSwiper()">
              <el-upload :disabled="true" class="avatar-uploader" action="" :show-file-list="false">
                <i class="el-icon-plus avatar-uploader-icon">
                  <span class="text">新增轮播图</span>
                </i>
              </el-upload>
              <img src="" alt="">
          </div>
          <div class="AddSwiper SwiperImg" v-for="(item,index) in requestForm.backgroundVoList" :key="index">
            <img :src="item.imageUrl" alt="">
            <span class="SwiperName">{{item.imageTitle}}</span>
            <div class="SwiperNum">{{index + 1}}</div>
            <div class="SwiperIcon">
              <i class="el-icon-arrow-left SwiperIcon_left" @click="SwiperPrev(index)" v-show="index !== 0"></i>
              <i class="el-icon-arrow-right SwiperIcon_right" @click="SwiperNext(index)" v-show="index !== requestForm.backgroundVoList.length-1"></i>
              <i class="el-icon-edit-outline" @click="SwiperEdit(index)"></i>
              <i class="el-icon-delete" @click="SwiperDel(index)"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- (4) 登录页联系方式 -->
      <div class="section mt20">
        <h1>登录页联系方式设置</h1>
        <div class="setState Message">
            <p class="numExplit">此联系方式将同步应用到登录页方便用户遇到问题时联系咨询&nbsp;&nbsp;&nbsp;&nbsp;<span @click="ShowLoginHTML"  style="cursor: pointer;">查看效果</span></p>
            <div class="LoginMessage">
                <!-- QQ 设置 -->
                <div class="qq_Set">
                  <div class="MessageDescripe">
                    <span>QQ</span>
                    <el-switch v-model="requestForm.qq.isOpen" :active-value="1" :inactive-value="0"></el-switch>
                  </div>
                  <div class="Form_Item">
                    <p>添加客服QQ<span>（最多支持三个）</span></p>
                    <div v-for="(item, index) in requestForm.qq.qqlist" :key="index" class="inputBox">
                      <el-input v-model="requestForm.qq.qqlist[index]" placeholder="请输入"></el-input>
                      <i v-if="index !== 0" class="el-icon-delete" @click="deleteqq(index)" style="color: #006aff"></i>
                    </div>
                    <span :class="{addIp: true, notAddIp: requestForm.qq.qqlist.length > 2}" @click="addQQ">+ 增加qq号</span>
                  </div>
                </div>
                <!-- E-mail 设置 -->
                <div class="E-mail_Set">
                  <div class="MessageDescripe">
                    <span>邮箱</span>
                    <el-switch v-model="requestForm.email.isOpen" :active-value="1" :inactive-value="0"></el-switch>
                  </div>
                  <div class="Form_Item">
                    <p>添加客服邮箱<span>（最多支持三个）</span></p>
                    <div v-for="(item, index) in requestForm.email.emailList" :key="index" class="inputBox">
                      <el-input v-model="requestForm.email.emailList[index]" placeholder="请输入"></el-input>
                      <i v-if="index !== 0" class="el-icon-delete" @click="deleteemail(index)" style="color: #006aff"></i>
                    </div>
                    <span class="addIp" :class="{notAddIp: requestForm.email.emailList.length > 2}" @click="addemail">+ 增加邮箱</span>
                  </div>
                </div>
                <!-- Phone 设置 -->
                <div class="Phone_Set">
                  <div class="MessageDescripe">
                    <span>电话</span>
                    <el-switch v-model="requestForm.phone.isOpen" :active-value="1" :inactive-value="0"></el-switch>
                  </div>
                  <div class="Form_Item">
                    <p>添加客服电话<span>（最多支持三个）</span></p>
                    <div v-for="(item, index) in requestForm.phone.phoneList" :key="index" class="inputBox">
                      <el-input v-model="requestForm.phone.phoneList[index]" placeholder="请输入"></el-input>
                      <i v-if="index !== 0" class="el-icon-delete" @click="deletePhone(index)" style="color: #006aff"></i>
                    </div>
                    <span class="addIp" :class="{notAddIp: requestForm.phone.phoneList.length > 2}" @click="addPhone">+ 增加电话</span>
                  </div>
                </div>
            </div>
        </div>
      </div>

    </div>

    <!-- 新增/编辑 轮播图弹窗 -->
    <ots-custom-dialog :dialog.sync="AddSwiperDialog" :title="SwiperSetFN ? '新增轮播图' : '编辑轮播图'" width="640px">
      <template v-slot:content>
        <div class="exportDialog">
          <el-form :model="Swiper" :rules="SwiperRules" ref="Swiper">
            <h2>上传图片</h2>
            <div class="Upload_Swiper">
              <el-form-item class="Upload_SwiperDialog">
                <el-upload class="avatar-uploader" action="" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :http-request="uploadSwiper">
                  <img v-if="Swiper.imageUrl" :src="Swiper.imageUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon">
                    <span>点击上传</span>
                  </i>
                </el-upload>
              </el-form-item>
              <div class="Swiper_Descripe">
                <p class="title">要求：</p>
                <p class="text">支持jpg、jpeg、png图片格式；</p>
                <p class="text">建议尺寸不小于800*600像素。</p>
              </div>
            </div>
            <h2>文案描述</h2>
            <el-form-item label="主标题" prop="imageTitle">
              <el-input placeholder="请输入主标题文字" v-model="Swiper.imageTitle"></el-input>
            </el-form-item>
            <!-- prop="imageSubtitle" -->
            <el-form-item label="阐述说明" class="Swiper_textarea" prop="imageSubtitle">
              <el-input placeholder="请输入" type="textarea" v-model="Swiper.imageSubtitle" >
              </el-input>
              <!-- <span class="text">{{Swiper.imageSubtitle.length}}/100</span> -->
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="AddSwiperDialog = false">取消</el-button>
        <el-button round type="primary" @click="AddSwiperSet()">确定</el-button>
      </template>
    </ots-custom-dialog>
    
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "TenantCustom",
  data() {
    return {
      saveMethods: "save",
      backMethods: "goIndex",
      DefaultLOGO: require('@/assets/img/customDefault.png'),
      AddSwiperDialog: false,
      requestForm: {
        systemName: '',
        loginPageTitle: '',
        logoUrl: '',
        isUsedLogo: 0,
        backgroundVoList: [],
        qq: {
          qqlist: [],
          isOpen: '',
        },
        email: {
          emailList: [],
          isOpen: '',
        },
        phone: {
          phoneList: [],
          isOpen: '',
        },
        welcomeMsgFlag: 0,
        welcomeContent: '',
      },
      isUseDefaultLogo: 1,
      imageUrl: '',
      value001: 1,
      SwiperSetFN: '',
      Swiper: {
        imageUrl: '',
        imageTitle: '',
        imageSubtitle: '',
      },
      SwiperRules: {
        imageTitle: [{ required: false,min: 0, max: 50, message: '标题最多为50字！', trigger: "blur" }],
        imageSubtitle: [{ required: false,min: 0, max: 50, message: '阐述说明最多为50字！', trigger: "blur" }],
      },
    }
  },

  computed: {
    IsRightSystemName() {
      let titleReg = /^[a-zA-Z0-9\u4e00-\u9fa5\,，]+$/
      if (!this.requestForm.systemName) {
        this.$message.warning('“系统名称”不可以为空！')
        return false;
      } else if (!(titleReg.test(this.requestForm.systemName))) {
        this.$message.warning('“系统名称”不可以含有@<>等无效字符！')
        return false
      } else if (this.requestForm.systemName.length < 2 || this.requestForm.systemName.length > 20) {
        this.$message.warning('“系统名称”请设置2~20个字符！')
        return false
      } else {
        return true
      }
    }
  },

  mounted(){
    this.SAVE_PAGE_THIS(this);
    this.initData();
  },

  methods: {
    ...mapMutations(["SAVE_PAGE_THIS"]),

    initData(){
      let params = {tenantCode: window.localStorage.getItem('tenant')}

      this.$api.system.getCustom(params).then(res=>{
        this.requestForm.loginPageTitle = res.data.loginPageTitle
        this.requestForm.systemName = res.data.systemName
        this.requestForm.logoUrl = res.data.logoUrl
        this.requestForm.backgroundVoList = res.data.backgroundVoList
        this.requestForm.isUsedLogo = Number(res.data.isUsedLogo)

        this.requestForm.email = res.data.email;
        this.requestForm.qq = res.data.qq;
        this.requestForm.phone = res.data.phone;

        this.requestForm.qq.qqlist = res.data.qq.qqlist ? res.data.qq.qqlist : []
        this.requestForm.email.emailList = res.data.email.emailList ? res.data.email.emailList : []
        this.requestForm.phone.phoneList = res.data.phone.phoneList ? res.data.phone.phoneList : []

        this.requestForm.qq.isOpen = Number(this.requestForm.qq.isOpen)
        this.requestForm.email.isOpen = Number(this.requestForm.email.isOpen)
        this.requestForm.phone.isOpen = Number(this.requestForm.phone.isOpen)

        this.requestForm.welcomeMsgFlag = res.data.welcomeMsgFlag;
        this.requestForm.welcomeContent = res.data.welcomeContent;
      })
    },

    // 返回首页
    goIndex(){
      this.$router.push({name: 'index'})
    },

    // 保存
    save(){
      let params = {...this.requestForm}

      let isQqNumberCheck = /^[1-9]{1}[0-9]{4,14}$/;
      let phoneReg = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/
      let emailReg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/

      // 校验 系统名称
      if (!this.IsRightSystemName) {
        let systemName = this.requestForm.systemName
        this.requestForm.systemName = '弘成慧考平台'
        this.requestForm.systemName = systemName
        return
      }

      if(this.requestForm.welcomeMsgFlag == 1 && this.requestForm.welcomeContent.trim().length <= 0){
        this.$message.warning('请设置欢迎语！')
        return;
      }

      // 校验 QQ
      for (let i = 0; i < params.qq.qqlist.length; i++) {
        if (!(isQqNumberCheck.test(params.qq.qqlist[i])) && params.qq.qqlist[i].length > 0) {
          this.$message.warning(`QQ账号 “${params.qq.qqlist[i]}” 格式错误`)
          return false
        }
      }

      // 校验 手机号
      for (let i = 0; i < params.phone.phoneList.length; i++) {
        if (!(phoneReg.test(params.phone.phoneList[i])) && params.phone.phoneList[i].length > 0) {
          this.$message.warning(`手机号 “${params.phone.phoneList[i]}” 格式错误`);
          return false
        }
      }

      // 校验 邮箱
      for (let i = 0; i < params.email.emailList.length; i++) {
        if (!(emailReg.test(params.email.emailList[i])) && params.email.emailList[i].length > 0) {
          this.$message.warning(`邮箱 “${params.email.emailList[i]}” 格式错误`);
          return false
        }
      }

      params.backgroundVoList = JSON.stringify(params.backgroundVoList)
      params.qq = JSON.stringify(params.qq)
      params.email = JSON.stringify(params.email)
      params.phone = JSON.stringify(params.phone)
      this.$api.system.saveCustom(params).then(res=>{
        if (res.code == 1) {
          this.$message.success('保存成功')
        }
      })
    },

    // 系统名称校验
    ChangeSystemName(){
      let titleReg = /^[a-zA-Z0-9\u4e00-\u9fa5\,，]+$/

      if (!this.requestForm.systemName) {
        this.$message.warning('“系统名称”不可以为空！')
      } else if (this.requestForm.systemName.length > 20) {
        this.$message.warning('“系统名称”最多不超过 20 个汉字！')
      } else if (!(titleReg.test(this.requestForm.systemName))) {
        this.$message.warning('“系统名称”不可以含有@<>等无效字符！')
      } else if (this.requestForm.systemName.length < 2 || this.requestForm.systemName.length > 20) {
        this.$message.warning('“系统名称”请设置2~20个字符！')
      }

    },

    // LOGO 文件
    uploadLogo(data){
      let that = this;
      let fileData = data.file;
      let reader = new FileReader();
      reader.readAsDataURL(fileData);
      reader.onload = function (e) {
        if (e.currentTarget.result) {
          that.requestForm.logoUrl = e.currentTarget.result;
        }
      };
    },

    // LOGO文件
    Success_LOGO(res, file) {
      this.requestForm.logoUrl = URL.createObjectURL(file.raw);
    },

    // LOGO 图片验证
    beforeUpload_LOGO(file) {
      const isJPG = file.type === 'image/jpeg' || file.type == 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 8;
      if (!isJPG) {
        this.$message.error('请上传正确的图片文件（文件格式 JPG，JPEG 或 PNG）！');
      }
      if (!isLt2M) {
        this.$message.error('上传LOGO图片大小不能超过 8MB!');
      }
      return isJPG && isLt2M;
    },

    // 登录页轮播图设置
    // 轮播图前调
    SwiperPrev(index){
      this.requestForm.backgroundVoList[index] = this.requestForm.backgroundVoList.splice(index-1, 1, this.requestForm.backgroundVoList[index])[0]
    },

    // 轮播图后调
    SwiperNext(index){
      this.requestForm.backgroundVoList[index] = this.requestForm.backgroundVoList.splice(index+1, 1, this.requestForm.backgroundVoList[index])[0]
    },

    // 删除轮播图
    SwiperDel(index){
      this.requestForm.backgroundVoList.splice(index, 1)
    },

    // 编辑轮播图
    SwiperEdit(index) {
      this.Swiper = {...this.requestForm.backgroundVoList[index]}
      this.SwiperNum = index
      this.AddSwiperDialog = true
      this.SwiperSetFN = false
    },

    // 新增轮播图弹窗
    AddSwiper(){
      if (this.requestForm.backgroundVoList.length > 4) {
        this.$message.warning('轮播图设置最多为5个！')
        return;
      }
      this.Swiper.imageUrl = ''
      this.Swiper.imageTitle = ''
      this.Swiper.imageSubtitle = ''
      this.AddSwiperDialog = true
      this.SwiperSetFN = true
    },

    // 轮播图图片(新增/编辑)
    uploadSwiper(data){
      let that = this;
      let fileData = data.file;
      let reader = new FileReader();
      reader.readAsDataURL(fileData);
      reader.onload = function (e) {
        if (e.currentTarget.result) {
          that.Swiper.imageUrl = e.currentTarget.result;
        }
      };
    },

    // 执行新增轮播图
    AddSwiperSet(){

      this.$refs["Swiper"].validate((valid)=>{
        if(valid){
          let params = {...this.Swiper}
          if (!params.imageUrl) {
            this.$message.warning('请上传图片！')
            return
          }
          if (this.SwiperSetFN) {
            this.requestForm.backgroundVoList.push(params)
          } else {
            this.requestForm.backgroundVoList[this.SwiperNum] = params;
          }
          this.AddSwiperDialog = false
        }
      })

    },

    // 添加QQ
    addQQ(){
      if (this.requestForm.qq.qqlist.length > 2) {
        return
      }
      let qqItem = ''
      this.requestForm.qq.qqlist.push(qqItem);
    },

    // 添加EMail
    addemail(){
      if (this.requestForm.email.emailList.length > 2) {
        return
      }
      let emailItem = ''
      this.requestForm.email.emailList.push(emailItem);
    },

    // 添加Phone
    addPhone(){
      if (this.requestForm.phone.phoneList.length > 2) {
        return
      }
      let PhoneItem = ''
      this.requestForm.phone.phoneList.push(PhoneItem);
    },

    // 删除QQ
    deleteqq(i){
      this.requestForm.qq.qqlist = this.requestForm.qq.qqlist.filter((item, index, arr) => {
        return index !== i;
      });
    },

    // 删除EMail
    deleteemail(i){
      this.requestForm.email.emailList = this.requestForm.email.emailList.filter((item, index, arr) => {
        return index !== i;
      });
    },

    // 删除Phone
    deletePhone(i){
      this.requestForm.phone.phoneList = this.requestForm.phone.phoneList.filter((item, index, arr) => {
        return index !== i;
      });
    },

    // 查看效果
    ShowLoginHTML(){
      let params = {...this.requestForm}
      params.backgroundVoList = JSON.stringify(params.backgroundVoList)
      params.qq = JSON.stringify(params.qq)
      params.email = JSON.stringify(params.email)
      params.phone = JSON.stringify(params.phone)
      let routeUrl = this.$router.resolve({name: 'TenantCustomShow',query: params})
      window.open(routeUrl.href, '_blank')
    },

    // ShowLoginHTML(){
    //   let params = {...this.requestForm}
    //   params.backgroundVoList = JSON.stringify(params.backgroundVoList)
    //   params.qq = JSON.stringify(params.qq)
    //   params.email = JSON.stringify(params.email)
    //   params.phone = JSON.stringify(params.phone)
    //   let routeUrl = this.$router.resolve({name: 'TenantCustomShow',query: params})
    //   window.open(routeUrl.href, '_blank')
    // },

    // 添加/编辑轮播图文件
    handleAvatarSuccess(res, file) {
      this.Swiper.imageUrl = URL.createObjectURL(file.raw)
    },

    // 轮播图验证
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type == 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 8;
      if (!isJPG) {
        this.$message.error('请上传正确的图片文件（文件格式 JPG，JPEG 或 PNG）！');
      }
      if (!isLt2M) {
        this.$message.error('上传轮播图片大小不能超过 8MB!');
      }
      return isJPG && isLt2M;
    }

  },

};
</script>

<style lang="less" scoped>
.systemBox {
  background: #fff;
  padding: 20px 24px;
  border-radius: 8px !important;
  .section {
    border-bottom: 1px solid #f1f2f5;
    h1 {
      color: #2d2f33;
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 32px;

      span {
        font-size: 14px;
        color:rgb(254, 89, 88);
      }
    }
    span {
      line-height: 35px;
    }
    .setState {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin-bottom: 40px;
      p {
        width: 100%;
        margin-top: 16px;
        a:first-child {
          text-decoration:underline;
        }
        a {
          color: #45494D;
        }
      }
      span {
        display: block;
        width: 112px;
        color: #45494d;
        text-align: right;
        margin-right: 16px;
      }
      em {
        position: relative;
        margin-left: 25px;
        z-index: 1;
        font-style: normal;
      }
      .el-input {
        width: 160px;
        height: 36px;
      }

      // LOGO 设置
      .el-radio-group {
        margin-left: 64px;
        display: flex;
        width: auto;
        box-sizing: border-box;
        .el-radio {
          display: flex;
          align-items: center;
          margin: 0;
          margin-bottom: 0px;
          margin-left: 64px;
          /deep/ .el-radio__label {
            color: #606266;
            display: flex;
            align-items: center;
            .LOGOBorder {
              width: 180px;
              height: 66px;
              margin-left: 16px;
              background: #DADDE6;
              border-radius: 4px;
              overflow: hidden;
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: 180px;
                height: 66px;
              }
              .avatar-uploader .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                .text {
                  width: 56px;
                  display: inline-block;
                  text-align: center;
                  height: 20px;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #9299A6;
                  line-height: 20px;
                }
              }
              .avatar-uploader-icon {
                display: flex;
                align-items: center;
                justify-content: center;
                color: #8c939d;
                width: 180px;
                height: 66px;
                text-align: center;
                box-sizing: border-box;
              }
            }
          }
        }
      }
      .LogoSet {
        width: auto;
        color: #9299A6;
        margin-left: 16px;
      }
      @media screen and (max-width: 1418px) {
        .LogoSet {
          width: auto;
          color: #9299A6;
          margin-top: 16px;
          margin-left: 128px;
        }
      }
      // 登录页轮播图设置
      .numExplit {
        font-size: 14px;
        color: #9299a6;
        margin-left: 128px;
        span {
          display: inline;
          color: #006aff;
          font-weight: 700;
        }
      }
    }
  }

  .setState.SetWelcome {
    padding-left: 128px;
    /deep/ .el-radio-group{
      margin:0px;
      .el-radio{
        margin-left:20px;
      }
    }
    /deep/ .el-input__inner{
      width:500px;
    }
    p{
      margin-top: 25px;
    }
  }
  // Swiper 设置
  .setState.SetSwiper {
    padding-left: 128px;
    .numExplit {
      margin-left: 0;
      margin-top: 0;
      margin-bottom: 24px;
    }
    .ShowLastSwiper {
      margin-left: 24px;
      display: inline-block;
      width: 98px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #006AFF;
      line-height: 20px;
      font-weight: 700;
    }
    .AddSwiper {
      margin-bottom: 32px;
      margin-right: 16px;
      width: 320px;
      height: 213px;
      background: #F8F9FC;
      border-radius: 4px;
      .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        .text {
          display: block;
          width: 100%;
          text-align: center;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #9299A6;
          line-height: 20px;
          margin-top: 16px;
        }
      }
      .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        padding-top: 72px;
        width: 320px;
        height: 213px;
        text-align: center;
        box-sizing: border-box;
      }
      .avatar {
        width: 320px;
        height: 213px;
        display: block;
      }

      
    }
    .AddSwiper.SwiperImg{
      position: relative;
      margin-left: 0px;
      margin-right: 16px;
      margin-bottom: 32px;
      &>img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
      .SwiperName {
        width: auto;
        max-width: 180px;
        position: absolute;
        text-align: left;
        left: 16px;
        bottom: 16px;
        font-size: 15px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 22px;
        display: block;

      }
      .SwiperNum {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: rgba(000, 000, 000, 0.5);
        color: #fff;
        position: absolute;
        top: 8px;
        left: 8px;
        text-align: center;
        line-height: 24px;
      }
      .SwiperIcon {
        position: absolute;
        right: 16px;
        bottom: 16px;
        &>i{
          font-size: 16px;
          line-height: 16px;
          color: #fff;
          margin-left: 12px;
          cursor: pointer;
        }
        .SwiperIcon_left,.SwiperIcon_right {
          display: inline-block;
          border-radius: 50%;
          width: 16px;
          height: 16px;
          border: 1px solid #FFF;
        }
      }
    }
  }

  // qq | E-mail | Phone 联系方式
  .setState {
    .LoginMessage {
      max-width: 1340px;
      display: flex;
      flex-wrap: wrap;
      margin-left: 128px;
      &>div {
        width: 400px;
        height: 230px;
        margin-right: 42px;
        margin-bottom: 16px;
        .MessageDescripe {
          display: flex;
          justify-content: left;
          align-items: center;
          height:  20px;
          margin-bottom: 10px;
          span {
            width: 28px;
            height: 20px;
            font-size: 14px;
            color: #45494D;
            display: inline-block;
            line-height: 20px;
            text-align: left;
          }
          /deep/ .el-switch {
            height: 16px;
          }
        }
      }
      .Form_Item {
        width:360px;
        height: 200px;
        border-radius: 4px;
        margin-left: 40px;
        overflow-y:scroll;
        padding: 24px 32px;
        box-sizing: border-box;
        background: #F8F9FC;
        &>p {
          margin: 0;
          margin-bottom: 16px;
          height: 20px;
          line-height: 20px;
          &>span {
            display: inline-block;
            height: 20px;
            color: #9299A6 ;
          }
        }
        .inputBox {
          display: flex;
          height: 36px;
          line-height: 36px;
          justify-items: center;
          vertical-align: middle;
          margin-bottom: 8px;
          /deep/ .el-input {
            width: 240px;
            height: 36px;
            line-height: 36px;
          }
          span {
            margin: 0 11px;
          }
          i {
            margin: 12px 0 0 20px;
            color: #006aff;
          }
        }
        .addIp {
          display: inline-block;
          width: 200px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #006AFF;
          line-height: 20px;
          text-align: left;
          margin-top: 8px;
        }
        .addIp.notAddIp {
          opacity: 0.5;
        }
      }
    }
  }
  .setState.Message {
    .numExplit {
      margin-top: 0;
      margin-bottom: 24px;
    }
  }

}

// 弹窗
.exportDialog {
  h2 {
    font-size: 16px;
    color: #2D2F33 ;
    margin-bottom: 24px;
  }

  .el-input {
    /deep/ .el-input__inner {
      width: 568px!important;
    }
  }

  .el-form-item.Swiper_textarea {
    .el-form-item__content {
      position: relative;
      .el-textarea {
        /deep/ .el-textarea__inner {
          height: 108px;
        }
      }  
    }
    .text {
      color: #C2C6CC;
      display: inline;
      position: absolute;
      bottom: 6px;
      right: 14px;
    }
  }


  .Upload_Swiper {
    width: 100%;
    margin-bottom: 24px;
    display: flex;
    .Upload_SwiperDialog {
      width: 240px;
      .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 8px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        background: #F8F9FC ;
        color: #8c939d;
        width: 240px;
        height: 160px;
        text-align: center;
        border-radius: 8px;
        padding-top: 50px;
        box-sizing: border-box;
        span {
          margin-top: 8px;
          display: block;
          width: 100%;
          height: 20px;
          font-size: 16px;
        }
      }

      .avatar-uploader-icon::before{
        height: 28px;
      }

      .avatar {
        border-radius: 8px;
        width: 240px;
        height: 160px;
        display: block;
      }
    }

    .Swiper_Descripe {
      width: 320px;
      height: 160px;
      padding-left: 16px;
      box-sizing: border-box;
      .title {
        font-size: 13px;
        color: #45494D;
        margin: 8px 0;
      }
      .text {
        font-size: 13px;
        color: #9299A6;
        line-height: 22px;
      }
    }
  }
}

</style>
